module.exports = __webpack_public_path__ + "img/charging-hub-rejected-semipublic.88bb6e04.svg";